import { Component } from '@angular/core';

@Component({
  selector: 'app-admin-manage-program-orders',
  templateUrl: './admin-manage-program-orders.component.html',
  styleUrls: ['./admin-manage-program-orders.component.css']
})
export class AdminManageProgramOrdersComponent {

}
